import React from 'react';
import { twMerge } from 'tailwind-merge';

interface UploadProps {
  className?: string;
  width?: number;
  height?: number;
}

const UploadIcon = function UploadIcon({
  className,
  width,
  height,
}: UploadProps): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <path className={twMerge(className, 'fill-transparent')} stroke="#828A97" d="M12 5L11.6464 4.64645L12 4.29289L12.3536 4.64645L12 5ZM12.5 14C12.5 14.2761 12.2761 14.5 12 14.5C11.7239 14.5 11.5 14.2761 11.5 14L12.5 14ZM6.64645 9.64645L11.6464 4.64645L12.3536 5.35355L7.35355 10.3536L6.64645 9.64645ZM12.3536 4.64645L17.3536 9.64645L16.6464 10.3536L11.6464 5.35355L12.3536 4.64645ZM12.5 5L12.5 14L11.5 14L11.5 5L12.5 5Z" fill="#828A97" />
      <path className={twMerge(className, 'fill-transparent')} d="M5 16L5 17C5 18.1046 5.89543 19 7 19L17 19C18.1046 19 19 18.1046 19 17V16" stroke="#828A97" />
    </svg>
  );
};

UploadIcon.defaultProps = {
  className: '',
  width: 24,
  height: 24,
};

export default UploadIcon;
